import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // Availability changes as people book; keep reads fresh-ish by default and
      // let the rooms pages shorten this further.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
